'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');
var jsxRuntime = require('react/jsx-runtime');

var SvgChartDown64 = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = tslib_es6.__rest(_a, ["title", "titleId"]);
    return (jsxRuntime.jsxs("svg", tslib_es6.__assign({ width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-labelledby": titleId }, props, { children: [title ? jsxRuntime.jsx("title", tslib_es6.__assign({ id: titleId }, { children: title })) : null, jsxRuntime.jsxs("g", tslib_es6.__assign({ fill: "none", fillRule: "evenodd" }, { children: [jsxRuntime.jsx("path", { fill: "none", d: "M0 .5h64v64H0z" }), jsxRuntime.jsx("path", { d: "M11.324 51.196h40m-37.6-26.087h5.218v26.087h-5.218V25.109Zm10.003 12.174h5.217v13.913h-5.217V37.283Zm10.003-3.479h5.217v17.392H33.73V33.804ZM43.732 42.5h5.218v8.696h-5.218V42.5Zm-1.739-12.174h6.957V23.37M16.602 12.935l10.72 8.695 10.28-3.478 11.18 12.174", stroke: "currentColor" })] }))] })));
};

exports.default = SvgChartDown64;
